import * as React from 'react';

import FileImage16 from './FileImage16';

export const fileImage16 = () => <FileImage16 />;

export default {
    title: 'Icon/Fill/FileImage16',
    component: FileImage16,
    parameters: {
        notes: "`import FileImage16 from 'box-ui-elements/es/icon/fill/FileImage16';`",
    },
};
